import { all } from "redux-saga/effects";

import authentication from "./authentication";
import application from "./application";
import fileUpload from "./fileUpload";
import user from "./user";

export default function* () {
  yield all([
    ...authentication,
    ...fileUpload,
    ...application,
    ...user
  ]);
}
